/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Action_BlockInputs */



/**
* | output |
* | --- |
* | "Block & Audit Log" |
*
* @param {Compliance_Copilot_Action_BlockInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_action_block = /** @type {((inputs?: Compliance_Copilot_Action_BlockInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Action_BlockInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Blockieren & Audit-Protokoll")
	return /** @type {LocalizedString} */ ("Block & Audit Log")
});